import type { RadiusScale } from './types';

export const BRAVEMOVE_RADIUS: RadiusScale = {
  none: 0,
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  pill: 999,
};
